import { createRouter, createWebHistory } from 'vue-router'
// import { VueRouter } from 'vue-router'
// import { createRouter } from 'vue-router'
// import Home from '../views/Home.vue'
import ZodiacSigns from '../views/ZodiacSigns.vue'
import SignProfiles from '../views/SignProfiles.vue'
import NotFound from '../views/NotFound.vue'
import FindMySign from '../views/FindMySign.vue'


const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/',
    component: ZodiacSigns,
    name: 'ZodiacSigns',
  },
  {
    path: '/zodiacsigns',
    name: 'zodiacSigns',
    component: ZodiacSigns,
    props: true
  },
  {
    path: '/signprofiles',
    component: SignProfiles,
    name: 'SignProfiles',
    props: true
  },
  {
    path: '/zodiacsigns/:signId',
    component: SignProfiles,
    name: 'SignProfiles',
    meta: {isAZodiacSign: true},
    props: true
  },
  {
    path: '/findmysign',
    component: FindMySign,
    name: 'FindMySign',
    props: true
  },
  { path: '/notfound', 
    name: 'NotFound',
    component: NotFound
   },
  // { path: '*', component: NotFound },

]


const router = createRouter({
  // mode: "history",
  // history: createWebHashHistory(),
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes
})


// const router = new VueRouter({
//   mode: 'history',
//   routes
// })


//Checks every route in the app
// router.beforeEach((to, from, next) =>{
//   console.log('route guard', from, next, to)
 
//   //it is a zodiac sign == true 
//   if (to.meta.isAZodiacSign) {

    // console.log('route guard TRUE: check variable before route change')
    //INTERNAL CHECK FOR VARIABLE--MOVED TO COMPONENET 
    //   //check variable before route change
    //   if('VALUE TO CHECK' == undefined ){
    //     console.log('route guard UNDEFINED: no name match in store- redirect to not found page')
    //     //redirect to unauth component page
    //       next({
    //         name: "NotFound"
    //       });
    //   } else {
    //     console.log('route guard FOUND: name match in store-continue flow')
    //     //name found. continue with the flow
    //     next();
    //   }


//   } else {
//     console.log('route guard FALSE')
//     next()
//   }

// });


export default router
